import React from 'react';
import { SectionHeader, KPICard } from '../components';

export function AnalyticsPage({ rows }) {
  const a = rows.analytics || {};
  const series = a.revenue_series || [];
  const total = series.reduce((s, v) => s + v, 0);
  const avg = series.length ? total / series.length : 0;
  return (
    <div>
      <SectionHeader title="Analytics" subtitle="Trends · last 30 days" />
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 14, marginBottom: 24,
      }}>
        <KPICard label="Total revenue" value={total} prev={a.revenue_prev} format="currency" />
        <KPICard label="Daily average" value={avg}                            format="currency" />
        <KPICard label="Conversion"    value={a.conversion} prev={a.conversion_prev} format="percent" />
        <KPICard label="Top source"    value={(a.top_sources?.[0]?.share || 0) * 100} format="percent" />
      </div>

      <BarChart series={series} />

      <div style={{ marginTop: 28 }}>
        <SectionHeader title="Traffic sources" />
        <div style={{
          background: 'var(--dash-bg-card)',
          border: '1px solid var(--dash-border)',
          borderRadius: 'var(--dash-radius)',
          padding: 18,
        }}>
          {(a.top_sources || []).map(s => (
            <div key={s.name} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ fontSize: 13, color: 'var(--dash-text)' }}>{s.name}</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--dash-text-muted)' }}>
                  {Math.round((s.share || 0) * 100)}%
                </span>
              </div>
              <div style={{ height: 6, background: 'rgba(15,15,30,0.05)', borderRadius: 999 }}>
                <div style={{
                  height: '100%',
                  width: `${(s.share || 0) * 100}%`,
                  background: 'var(--dash-primary)',
                  borderRadius: 999,
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function BarChart({ series }) {
  const data = series && series.length ? series : Array(30).fill(0);
  const max = Math.max(...data, 1);
  return (
    <div style={{
      padding: 18, background: 'var(--dash-bg-card)',
      border: '1px solid var(--dash-border)', borderRadius: 'var(--dash-radius)',
    }}>
      <div style={{
        fontSize: 11, fontWeight: 700, letterSpacing: '0.10em',
        textTransform: 'uppercase', color: 'var(--dash-text-muted)',
        marginBottom: 16,
      }}>
        Daily revenue
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 180 }}>
        {data.map((v, i) => (
          <div key={i} style={{
            flex: 1,
            height: `${(v / max) * 100}%`,
            minHeight: 2,
            background: 'var(--dash-primary)',
            opacity: 0.85,
            borderRadius: '4px 4px 0 0',
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '1'}
          onMouseLeave={e => e.currentTarget.style.opacity = '0.85'}
          title={`Day ${i+1}: €${v.toFixed(2)}`}
          />
        ))}
      </div>
    </div>
  );
}
